
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import AuditService from '@/services/audit.service';


@Component({})
export default class CommonField extends Vue {
  val: string | number | boolean = '';

  /** 审核【通过/不通过】 */
  @lazyInject(AuditService)
  protected auditService!: AuditService;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  value!: any;

  @Watch('value')
  async watchValue() {
    if (this.value == null) {
      this.val = '';
      return;
    }
    const params = {
      amapAtagId: this.value,
    };
    const res = await this.auditService.mainBusinessAtagList(params);
    if (res) {
      this.val = res.name || '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
